import { render, staticRenderFns } from "./Shopdetail.vue?vue&type=template&id=0f357c2c&"
import script from "./Shopdetail.vue?vue&type=script&lang=js&"
export * from "./Shopdetail.vue?vue&type=script&lang=js&"
import style0 from "./Shopdetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports